module.exports = __webpack_public_path__ + "348738e10fa2f37db8a354223caaa0a9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular-webfont.ttf
// module id = 222
// module chunks = 0